// Modo Carrera — Español.
/* eslint-disable no-template-curly-in-string */
const resources = {
    tiers: { facil: 'Fácil', medio: 'Medio', dificil: 'Difícil', imposible: 'Imposible' },

    common: {
        continue: 'Continuar',
        close: 'Cerrar',
        cancel: 'Cancelar',
        save: 'Guardar',
        confirm: 'Confirmar',
        back: 'Volver',
        yes: 'Sí',
        no: 'No',
        vs: 'vs',
        away: '@',
        free: 'Libre',
        go: 'Ir',
    },

    maintenance: {
        title: 'CARRERA DE ÉLITE EN MANTENIMIENTO',
        line1: 'Estamos mejorando el juego con un montón de novedades.',
        line2: '¡Pronto van a poder volver a jugar! 🙌',
        thanks: 'Gracias por la paciencia 💛',
        adminBanner: '🔧 Carrera de Élite EN MANTENIMIENTO — solo los admins pueden jugar. (Cambialo desde el panel de admin.)',
    },

    noauth: {
        title: '⚽ CARRERA DE ÉLITE',
        text: 'Necesitás iniciar sesión para jugar a Carrera de Élite. Así guardamos tu progreso y tus logros.',
        login: 'Iniciar sesión',
        backHome: 'Volver al inicio',
    },

    welcome: {
        emoji: '⚽💛',
        title: '¡Bienvenido a Carrera de Élite!',
        text1: 'Este juego es un poco diferente a los demás: no elegís un equipo armado, empezás con un jugador creado por vos mismo, desde cero.',
        text2: 'Vas a tener que ganarte cada convocatoria, cada título y cada pase a un club de élite con tus propias decisiones y resultados.',
        text3: 'Lo hicimos con muchísimo amor. Si te gusta, nos ayuda un montón que compartas tu carrera en redes sociales o con tus amigos. 💛',
        button: '¡Vamos a jugar!',
    },

    tour: {
        skip: 'Saltear',
        next: 'Siguiente',
        prev: 'Atrás',
        finish: '¡Entendido!',
        stepOf: 'Paso {{current}} de {{total}}',
        steps: {
            tables: {
                title: '📊 Tablas',
                text: 'Acá ves la tabla de tu liga y de las copas en las que participás. Se actualizan partido a partido.',
            },
            achievements: {
                title: '🏆 Logros',
                text: 'Tocá acá para ver todos los logros que podés conseguir en tu carrera, y tu progreso en cada uno.',
            },
            stats: {
                title: '⚡ Atributos',
                text: 'Acá administrás los atributos de tu jugador. A medida que sumás puntos, podés repartirlos como quieras.',
            },
            seleccion: {
                title: '🌍 Selección',
                text: 'Si tu nivel alcanza, te van a convocar a la selección de tu país. Acá seguís las clasificatorias y el Mundial.',
            },
            tactics: {
                title: '📋 Tácticas',
                text: 'Elegí la táctica de tu equipo antes de cada partido para sacarle el máximo provecho a tu jugador.',
            },
            simulate: {
                title: '▶️ Simular',
                text: 'Con estos botones avanzás partido a partido. También podés activar el modo automático para simular varios seguidos.',
            },
        },
    },

    loading: {
        text: 'Cargando Carrera de Élite...',
    },

    creator: {
        title: '⚽ CARRERA DE ÉLITE',
        subtitle: 'Creá tu jugador y empezá tu historia desde cero.',
        tabDatos: '📋 Datos',
        tabCabeza: '🧑 Cabeza',
        tabCuerpo: '👕 Cuerpo',
        defaultPlayerName: 'Tu jugador',
        nameLabel: 'Nombre',
        namePlaceholder: 'Tu nombre de jugador',
        nationalityLabel: 'Nacionalidad',
        nationalityPlaceholder: 'Elegí tu nacionalidad',
        positionLabel: 'Posición',
        physicalLabel: 'Físico',
        heightLabel: 'Altura',
        weightLabel: 'Peso',
        attributesLabel: 'Atributos · puntos a repartir',
        skinLabel: 'Piel',
        hairLabel: 'Peinado',
        hairColorLabel: 'Color de pelo',
        beardLabel: 'Barba',
        glassesLabel: 'Lentes',
        glassesColorLabel: 'Color de lentes',
        outfitLabel: 'Prenda',
        patternLabel: 'Patrón',
        primaryColorLabel: 'Color principal',
        secondaryColorLabel: 'Color secundario',
        secondaryColorHint: '(patrón / detalles)',
        shortsLabel: 'Short',
        socksLabel: 'Medias',
        bootsLabel: 'Botines',
        bootsStyleLabel: 'Estilo de botines',
        accessoryLabel: 'Accesorio',
        accessoryColorLabel: 'Color del accesorio',
        creating: 'Creando...',
        createButton: 'Crear personaje',
        customColorTitle: 'Elegir otro color',
    },

    avatar: {
        peinado: {
            shortFlat: 'Corto', shortWaved: 'Ondulado', shortCurly: 'Rulos corto', shortRound: 'Casquete',
            theCaesar: 'César', theCaesarAndSidePart: 'César con raya', sides: 'Costados',
            shavedSides: 'Rapado', straight01: 'Lacio', straight02: 'Lacio 2',
            straightAndStrand: 'Lacio con mechón', longButNotTooLong: 'Media melena',
            frizzle: 'Crespo', curly: 'Rulos', curvy: 'Ondulado largo', shaggy: 'Despeinado',
            bob: 'Carré', fro: 'Afro', froBand: 'Afro + vincha', dreads01: 'Rastas',
            dreads02: 'Rastas 2', dreads: 'Rastas largas', bun: 'Rodete', bigHair: 'Melena',
            shaggyMullet: 'Mullet', hat: 'Gorra', turban: 'Turbante', winterHat1: 'Gorro', pelado: 'Pelado',
        },
        barba: {
            ninguna: 'Sin barba', beardLight: 'Candado', beardMedium: 'Media',
            beardMajestic: 'Barbón', moustacheFancy: 'Bigote', moustacheMagnum: 'Bigotón',
        },
        lentes: {
            ninguno: 'Ninguno', round: 'Redondos', sunglasses: 'De sol', wayfarers: 'Wayfarer',
            prescription01: 'Recetados', prescription02: 'Recetados 2', kurt: 'Kurt', eyepatch: 'Parche',
        },
        atuendo: {
            remera: 'Remera', remera_v: 'Remera cuello V', manga_larga: 'Manga larga', buzo: 'Buzo / canguro',
            sueter: 'Suéter', campera: 'Campera', traje: 'Traje', conjunto: 'Conjunto deportivo',
        },
        patron: {
            liso: 'Liso', rayas_v: 'Rayas verticales', rayas_h: 'Rayas horizontales', banda: 'Banda',
        },
        botinEstilo: {
            clasico: 'Clásicos', altos: 'Media caña', franja: 'Con franja',
        },
        accesorio: {
            ninguno: 'Ninguno', capitan: 'Cinta de capitán', vincha: 'Vincha', guantes: 'Guantes', munequeras: 'Muñequeras',
        },
    },

    clubPicker: {
        title: 'ELEGÍ TU PRIMER CLUB',
        subtitle: '{{nombre}} · {{nacionalidad}} · {{posicion}} · Rating {{rating}}',
        hint: 'Estas son tus 3 opciones para arrancar tu carrera. Elegí una para continuar.',
        choose: 'Elegir',
        adminAnyClub: '🛠️ Admin: ir a cualquier club',
    },

    header: {
        achievementsTooltip: 'Logros conseguidos entre todas tus carreras',
        achievements: 'Logros',
        calledUp: 'Convocado a la selección',
        notCalledUp: 'El DT todavía no te considera apto para convocarte a tu selección',
        seasonLabel: 'Temporada {{n}}',
        ageYears: '{{n}} años',
        marketValue: '💰 ${{n}}M',
        statsTooltip: 'Goles y asistencias en la temporada actual',
        contractTooltip: 'Temporadas que quedan de contrato',
        contractYears_one: '📝 {{n}} año',
        contractYears_other: '📝 {{n}} años',
        suspended: '🟥 Suspendido {{n}}j',
    },

    next: {
        selectionNowTag: 'SELECCIÓN · AHORA',
        selectionNotCalledNote: '🚫 El DT no te consideró apto para esta convocatoria: tu selección juega sin vos.',
        laterTag: 'DESPUÉS',
        nowTag: 'AHORA',
        jornada: 'Jornada {{n}} · {{venue}}',
        home: 'Local',
        away: 'Visitante',
        idaResultPrefix: '🔁 Ida: ',
        koAutoPauseNote: '⏸ El modo automático se detiene en partidos de eliminatoria.',
    },

    mobile: {
        results: '📋 Resultados',
        tables: '📊 Tablas',
        selectionTab: '🌍 Selección',
        cupTab: 'Copa',
        leagueTab: '🏆 Liga',
    },

    status: {
        moral: '😤 Moral',
        openTactics: '📋 Pizarra táctica',
    },

    actions: {
        simulateFast: '⚡ Simular Jornada (Rápido)',
        simulateSlow: '🐢 Simular Jornada (Lento)',
        playEuroFast: '⚡ Jugar {{copa}} (Rápido)',
        playEuroSlow: '🐢 Jugar {{copa}} (Lento)',
        playSelectionFast: '⚡ Jugar Selección (Rápido)',
        playSelectionSlow: '🐢 Jugar Selección (Lento)',
        playMundialFast: '⚡ Jugar Mundial (Rápido)',
        playMundialSlow: '🐢 Jugar Mundial (Lento)',
        shortFast: '⚡ Rápido',
        shortSlow: '🐢 Lento',
        shortEuro: '⚡ {{copa}}',
        shortEuroSlow: '🐢 {{copa}}',
        shortSelection: '⚡ Selección',
        shortSelectionSlow: '🐢 Selección',
        shortMundial: '⚡ Mundial',
        shortMundialSlow: '🐢 Mundial',
        autoStart: '⏩ Simular Automático',
        autoStartShort: '⏩ Auto',
        autoStop: '⏸ Detener',
        attributes: '⚡ ATRIBUTOS',
        attributesShort: '⚡ Attr',
        seasonFinished: 'Temporada finalizada',
        simulating: 'Simulando...',
        fastTooltip: 'Simula la jornada al instante, sin animación',
        slowTooltip: 'Simula la jornada con animación minuto a minuto de tu partido',
        autoTooltip: 'Avanza jornadas automáticamente hasta que termine la temporada o llegue una oferta',
        retire: '🎙️ Retirarse',
    },

    results: {
        title: 'Últimos resultados',
        suspended: '🟥 Suspendido',
    },

    careerHistory: {
        title: '🏆 Carrera',
    },

    tables: {
        club: 'Club',
        country: 'País',
        played: 'PJ',
        won: 'PG',
        drawn: 'PE',
        lost: 'PP',
        goalsFor: 'GF',
        goalsAgainst: 'GC',
        goalDiff: 'DG',
        points: 'Pts',
        group: 'Gr',
        legendLibertadores: 'Copa Libertadores',
        legendSudamericana: 'Copa Sudamericana',
        legendChampions: 'Champions League',
        legendEuropa: 'Europa League',
        legendPromotion: 'Ascenso',
        legendRelegation: 'Descenso',
        legendLast16Direct: 'Octavos (directo)',
        legendPlayoff16: 'Playoff 16avos',
        legendEliminated: 'Eliminado',
        legendLast16DirectShort: 'Octavos',
        legendPlayoffShort: 'Playoff',
        conmebolOctavos2: 'Octavos (1º y 2º)',
        conmebolOctavos1: 'Octavos (1º)',
        conmebolDown: '3º → Sudamericana',
        conmebol16: '16avos (2º)',
        tbd: 'A definir',
        groupLetter: 'Grupo {{letter}}',
        tableTitle: 'Tabla — {{nombre}}',
    },

    competitions: {
        champions: 'Champions League',
        europa: 'Europa League',
        libertadores: 'Copa Libertadores',
        sudamericana: 'Copa Sudamericana',
        generic: 'Copa',
        groupStage: 'Fase de grupos',
        leaguePhase: 'Fase de liga',
        groupStageJ: 'Fase de grupos · J{{n}}',
        leaguePhaseJ: 'Fase de liga · J{{n}}',
        libertadoresGroupNote: '📋 Fase de grupos. 1º y 2º → octavos. 3º baja a Sudamericana.',
        sudamericanaGroupNote: '📋 Fase de grupos. 1º → octavos. 2º juega 16avos vs un 3º de Libertadores.',
        leaguePhaseNote: '📋 Fase de liga. Top 8 → octavos directo, 9-24 → playoff de 16avos.',
        teamAlive: 'tu equipo sigue ✅',
        teamEliminated: 'tu equipo fue eliminado ❌',
        championYou: '🏆 ¡Tu equipo es el CAMPEÓN!',
        championOther: '🏆 Campeón: {{nombre}}',
    },

    koRounds: {
        '16avos': '16avos de final',
        octavos: 'Octavos de final',
        cuartos: 'Cuartos de final',
        semis: 'Semifinal',
        final: 'Final',
    },

    months: {
        1: 'Enero', 2: 'Febrero', 3: 'Marzo', 4: 'Abril', 5: 'Mayo', 6: 'Junio',
        7: 'Julio', 8: 'Agosto', 9: 'Septiembre', 10: 'Octubre', 11: 'Noviembre', 12: 'Diciembre',
    },

    clasif: {
        uefaTexto: '1º → Mundial · 2º (y mejores 3º) → Repechaje · resto afuera',
        uefaDetalle: '12 grupos. El 1º de cada grupo va directo al Mundial (12 cupos). Los 12 segundos + los 4 mejores terceros juegan un repechaje por los 4 cupos restantes.',
        uefaPlayoffSub: '(los 12 segundos de grupo también van directo al repechaje)',
        asiaTexto: '1º y 2º → Mundial · mejor 3º → Repechaje · resto afuera',
        asiaDetalle: '4 grupos. El 1º y el 2º de cada grupo van directo al Mundial (8 cupos). Los 4 terceros juegan un repechaje por 1 cupo.',
        africaTexto: '1º → Mundial · 4 mejores 2º → Repechaje · resto afuera',
        africaDetalle: '9 grupos. El 1º de cada grupo va directo al Mundial (9 cupos). Los 4 MEJORES segundos (entre los 9 grupos) juegan un repechaje a partido único; el ganador se lleva el 10º y último cupo africano.',
        concacafTexto: '1º → Mundial · 2º → Repechaje cruzado · resto afuera',
        concacafDetalle: '4 grupos. El 1º de cada grupo va directo al Mundial (4 cupos). Los 4 segundos se cruzan (G1-G3, G2-G4) a ida y vuelta por los 2 cupos restantes.',
        conmebolTexto: '1º a 6º → Mundial · resto afuera',
        conmebolDetalle: 'Liga única (todos contra todos). Los primeros 6 de la tabla van directo al Mundial.',
        oceaniaTexto: '1º → Mundial · resto afuera',
        oceaniaDetalle: 'Liga única (todos contra todos). Solo el 1º de la tabla va al Mundial.',
        classifies: 'Clasifica',
        playoff: 'Repechaje',
        bestSecondsTitle: 'Segundos de cada grupo',
        bestThirdsTitle: 'Terceros de cada grupo',
        goesToPlayoffN: 'Va al repechaje (mejores {{n}})',
        mundialQualifyLegend: '1º y 2º → 16avos · mejores 3º también',
    },

    mundial: {
        bestThirdsTitle: '🥉 Mejores terceros (8 pasan a 16avos)',
        bestThirdsLegend: 'Pasa a 16avos (8 mejores terceros)',
        groupStage: '🌍 Mundial · Fase de grupos',
        groupStageDate: '🌍 Mundial · Grupos (fecha {{n}}/3)',
        finished: '🌍 Mundial · Finalizado',
        round: '🌍 Mundial · {{ronda}}',
        finalRound: '🌍 Mundial · Final',
        eliminatedSpectator: '🌍 Mundial · Quedaste afuera — mirá cómo termina',
        notQualifiedSpectatorHint: 'No clasificaste — seguí el Mundial. Avanzá para ver cómo sigue.',
        championPrefix: '🏆 Campeón: ',
        runnerUpLabel: ' · 🥈 {{nombre}}',
        groupLabel: 'Grupo {{letra}}',
        bracketTitle: 'Cuadro del Mundial',
        yourPath: 'Tu camino',
        groupPhaseTitle: 'Fase de grupos',
        pendingBracketNote: 'El cuadro se va a ir armando partido a partido.',
        outTitle: '🌍 Selección · Eliminado',
        outOfWorldCup: 'Tu selección quedó afuera del Mundial.',
        outOfWorldCupSub: 'No jugás más con la selección hasta las próximas clasificatorias (próximo ciclo).',
        playoffTitle: '🌍 Repechaje Mundial',
        playoffLeg: '{{ronda}} · Ida',
        playoffLegVuelta: '{{ronda}} · Vuelta',
        playoffRoundIda: 'Repechaje · Ida',
        playoffRoundVuelta: 'Repechaje · Vuelta',
        playoffRound: 'Repechaje',
        playoffSummaryPre: 'Llave a ida y vuelta vs ',
        playoffSummaryPost: ' por el último cupo. Global {{favor}}-{{contra}}.',
        playoffNote: 'Ganás por global → Mundial. Perdés → afuera.',
        prePlayoffTitle: '🌍 Pre-repechaje CONCACAF',
        prePlayoffSummary: 'Sos del bombo 4: pasá 2 rondas para entrar a la fase de grupos.',
        qualifiedTitle: '🌍 ✅ Clasificado al Mundial',
        qualifiedNote: '¡Tu selección jugará el próximo Mundial!',
        qualifyingTitle: '🌍 Eliminatorias · Año {{n}}/4',
    },

    modals: {
        attributes: {
            title: '⚡ Atributos · {{posicion}}',
            ratingLabel: 'Media',
            pointsLabel: 'Puntos a asignar:',
            resetButton: '♻️ Resetear todo (cuesta 1 punto)',
            removeAria: 'Quitar',
            addAria: 'Sumar',
        },
        achievements: {
            title: '🏆 Logros',
            subtitle: 'Se guardan entre todas tus carreras, con la fecha y el club con el que los conseguiste. El progreso de los logros de una sola carrera se reinicia al empezar otra.',
            close: 'Cerrar',
        },
        callup: {
            title: '¡Felicitaciones!',
            textPre: 'Fuiste convocado al ',
            textMid: ' con la selección de ',
            textPost: '.',
            worldCupWord: 'Mundial',
            text2: '¡El sueño de todo futbolista! Dejá todo en la cancha. 🏆',
            button: '¡Vamos!',
        },
        seleccion: {
            calledUp: '⭐ Convocado a la selección',
            notCalledUp: '🚫 El DT todavía no te considera apto para convocarte a tu selección.',
            phaseClasif: '🟡 Eliminatorias en curso',
            phaseClasificado: '✅ Clasificado al Mundial',
            phasePlayoff: '⚠️ A repechaje',
            phaseEliminado: '❌ Eliminado',
            cycleLine: ' · Ciclo {{ciclo}} / Año {{año}}/4',
            outOfWorldCup: 'Tu selección quedó afuera del Mundial.',
            outOfWorldCupSub: 'No jugás más con la selección hasta las próximas clasificatorias (próximo ciclo).',
            groupTableTitle: 'Tabla del grupo',
            upcomingTitle: 'Próximos partidos',
            upcomingLine: 'Año {{año}} · {{venue}} {{rival}} ({{estrellas}})',
            cycleStats: '📊 Este ciclo: <b>{{pj}}</b> PJ · <b>{{g}}</b> G · <b>{{a}}</b> A',
            careerStats: '🌍 Carrera: <b>{{pj}}</b> PJ · <b>{{g}}</b> G · <b>{{a}}</b> A · <b>{{w}}</b> Mundiales',
        },
        season: {
            title: 'Temporada {{n}} finalizada',
            finishedLine: 'Terminaste {{pos}}{{ord}} en {{liga}}.',
            yourLeague: 'tu liga',
            played: 'Partidos',
            goals: 'Goles',
            assists: 'Asistencias',
            minutes: 'Minutos',
            ratingLine: 'Valoración: {{prev}} → {{next}}',
            marketValueLine: 'Valor de mercado: ${{n}}M',
            promoted: '🔼 ¡Ascendiste a Primera División!',
            relegated: '🔽 Descendiste a Segunda División.',
        },
        liveMatch: {
            fallbackHeader: 'Jornada {{n}} · {{venue}}',
            qualifiersHeader: '🌍 Eliminatorias Mundial · Año {{n}}/3{{nc}}',
            notCalledShort: ' · 🚫 No convocado',
            prePlayoffHeader: '🌍 Pre-repechaje CONCACAF · {{ronda}}',
            playoffHeader: '🌍 Repechaje Mundial · {{ronda}}{{leg}}',
            legIda: ' · Ida',
            legVuelta: ' · Vuelta',
            mundialGroupHeader: '🌍 Mundial · Fase de grupos · Fecha {{n}}',
            mundialKOHeader: '🌍 Mundial · {{ronda}}',
            secondLegLine: '🔁 Vuelta · ida: <bold>{{score}}</bold> (global se define acá)',
            penaltiesTitle: '🥅 Definición por penales',
            suddenDeath: 'Muerte súbita',
            advancedPens: '✅ ¡Avanzaste {{favor}}-{{contra}} en los penales!',
            eliminatedPens: '❌ Eliminado {{contra}}-{{favor}} en los penales',
            kickingOn: 'Pateando…',
            ownGoal: '⚽ Gol tuyo',
            ownAssist: '🅰️ Asistencia tuya',
            opponentGoal: '⚽ {{equipo}}',
            goalFlashOwn: "⚽ ¡GOL TUYO! ({{min}}')",
            goalFlashOwnAssist: "🅰️ ¡Asistencia tuya! ({{min}}')",
            goalFlashOther: "⚽ Gol de {{equipo}} ({{min}}')",
        },
        evento: {
            title: 'Evento',
        },
        tacticas: {
            title: '📋 Pizarra táctica',
            done: 'Listo',
        },
        transfer: {
            titleDefault: 'Ofertas de traspaso',
            textDefault_one: 'Tenés {{n}} oferta de traspaso. ¿Qué querés hacer?',
            textDefault_other: 'Tenés {{n}} ofertas de traspaso. ¿Qué querés hacer?',
            titleExpiredRenewal: 'Se venció tu contrato',
            textExpiredRenewal: 'Tu club quiere renovarte, pero también te buscan otros equipos. Elegí renovar o fichar por otro club.',
            titleExpiredNoRenewal: 'Tu club no te renueva',
            textExpiredNoRenewal: 'Tu club decidió no renovarte el contrato. Tenés que elegir sí o sí uno de los siguientes clubes.',
            renewalTag: ' · Renovación',
            minutesWarn: "⚠️ Vas a jugar muy poco (~{{n}}'/partido)",
            minutesLimited: "🟡 Minutos limitados (~{{n}}'/partido)",
            minutesStarter: "✅ Titular (~{{n}}'/partido)",
            renewalContract_one: '📝 Contrato {{n}} año',
            renewalContract_other: '📝 Contrato {{n}} años',
            offerContract_one: '{{monto}}M · 📝 {{n}} año',
            offerContract_other: '{{monto}}M · 📝 {{n}} años',
            finishedFinal: 'terminó',
            goingPos: 'va',
            renew: 'Renovar',
            sign: 'Fichar',
            stay: 'Quedarme en mi club',
            adminAnyClub: '🛠️ Admin: ir a cualquier club',
        },
        adminClubPicker: {
            title: '🛠️ Admin: ir a cualquier club',
            hint: 'Solo para testing. Te ficha de una en el club que elijas, sin pasar por ofertas.',
            searchPlaceholder: 'Buscar club, liga o país...',
            go: 'Ir',
            close: 'Cerrar',
        },
        retire: {
            forcedBanner: 'A los {{n}} años decís adiós al fútbol profesional. ¡Qué carrera!',
            cardTitle: '⚽ FOOTY · CARRERA DE ÉLITE',
            statsTitle: 'Estadísticas',
            statPartidos: 'PARTIDOS',
            statGoles: 'GOLES',
            statAsistencias: 'ASISTENCIAS',
            statTitulos: 'TÍTULOS',
            trophiesTitle: 'Palmarés',
            league_one: 'Liga',
            league_other: 'Ligas',
            nationalTeamTitle: 'Selección Nacional',
            bestLine: 'Mejor: Mundial ciclo {{ciclo}} (edad {{edad}}) — {{result}}',
            bestLineWith: ' con {{pais}}',
            worldCupHash: 'Mundial #{{ciclo}} · edad {{edad}}',
            careerTitle: 'Trayectoria',
            footer: 'Jugá tu carrera en www.footy-games.com.ar',
            share: '📸 Compartir',
            download: '📥 Descargar',
            generating: 'Generando…',
            backButton: 'Volver',
            newCareer: 'Empezar nueva carrera',
            confirmRetire: 'Confirmar retiro',
        },
        nationality: {
            title: 'Elegí tu nacionalidad',
            close: 'Cerrar',
        },
    },

    toast: {
        offerPending: 'Tenés que decidir la oferta de traspaso antes de seguir.',
        matchdayError: 'Error al avanzar la jornada.',
        loadCareerError: 'Error al cargar tu partida.',
        loadClubOptionsError: 'Error al obtener opciones de club.',
        gameError: 'Error al crear la partida.',
        chooseClubError: 'Error al elegir el club.',
        adminChangeClubError: 'Error al cambiar de club (admin).',
        adminNowAt: '(Admin) Ahora jugás en {{nombre}}.',
        signedWith: '¡Fichado por {{nombre}}!',
        couldNotSave: 'No se pudo guardar tu progreso. Revisá tu conexión y probá de nuevo.',
        offerProcessError: 'Error al procesar la oferta. Probá de nuevo.',
        nameRequired: 'Ingresá un nombre para tu jugador.',
        nationalityRequired: 'Elegí tu nacionalidad.',
        attributesUpdated: 'Atributos actualizados.',
        seasonFinished: '¡Temporada finalizada!',
        seasonFinishedShort: 'Temporada finalizada.',
        dayOff: 'Tu equipo descansó esta jornada.',
        koPauseNote: '⏸ Es un partido de eliminatoria: jugalo vos (Rápido o Lento).',
        selectionTurnNote: '🌍 ¡Te toca con la selección! Jugá el partido vos (Rápido o Lento).',
        mundialTurnNote: '🌍 Estás en el Mundial. Jugá los partidos vos (Rápido o Lento).',
        worldCupGroupsDone: '🌍 Mundial: terminó la fase de grupos. Arrancan los 16avos.',
        worldCupGroupDate: '🌍 Mundial: se jugó la fecha {{n}}/3 de grupos.',
        worldCupFinished: '🌍 ¡Mundial terminado! Campeón: {{campeon}}.',
        worldCupRoundPlayed: '🌍 Mundial: se jugaron los {{ronda}}.',
        worldCupRoundPlayedWatch: '🌍 Mundial: se jugaron los {{ronda}}. Mirá cómo sigue el cuadro.',
        worldCupKOAdvance: '🌍 ¡Pasaste de fase! {{ronda}}: tu rival es {{rival}}.',
        worldCupStartedNotCalled: '🌍 Empieza el Mundial. El DT no te consideró apto para esta convocatoria: tu selección juega sin vos. Podés seguirlo en el panel.',
        suspendedLeague: '🟥 Suspendido por roja: te perdés esta jornada de liga.',
        wonLost: { won: 'Ganaste', lost: 'Perdiste', drawn: 'Empataste' },
        notCalledScore: '🌍 {{ronda}}: 🚫 No convocado — tu selección jugó sin vos {{score}} {{venue}} {{rival}}',
        prePlayoffToGroups: '   ✅ ¡A la fase de grupos!',
        prePlayoffEliminated: '   ❌ Eliminado en el pre-repechaje',
        playoffQualified: '   ✅ ¡Clasificado al Mundial!',
        playoffEliminated: '   ❌ Quedaste afuera del Mundial',
        worldChampion: '   🏆 ¡CAMPEÓN DEL MUNDO!',
        nextRound: '   ✅ A la próxima ronda',
        eliminatedWC: '   ❌ Eliminado del Mundial',
        suspendedCup: '🟥 Suspendido — tu equipo jugó sin vos {{score}} {{venue}} {{rival}}',
        aggregateScore: '   Global {{favor}}-{{contra}}{{pens}}',
        aggregatePens: ' · Penales {{favor}}-{{contra}}',
        champion: '   🏆 ¡CAMPEÓN!',
        qualifiedNextRound: '   ✅ Clasificado a la próxima ronda',
        eliminatedCup: '   ❌ Eliminado de la competición',
        imageDownloadedCopied: 'Imagen descargada y texto copiado. Pegalo en tu posteo 📸',
        imageDownloaded: 'Imagen de tu carrera descargada 📸',
        imageDownloaded2: 'Imagen de tu carrera descargada 📥',
        imageError: 'No se pudo generar la imagen.',
        retireError: 'Error al retirarse.',
        achievementUnlocked: '🏆 ¡Logro desbloqueado! {{titulo}}',
        eliminatorias: 'Eliminatorias · Año {{n}}/3',
        prePlayoff: 'Pre-repechaje CONCACAF',
        playoffIda: 'Repechaje (ida)',
        playoffVuelta: 'Repechaje (vuelta)',
        playoffPlain: 'Repechaje',
        worldCupGroupMatchday: 'Mundial · Fecha {{n}}',
        worldCupKO: 'Mundial · {{ronda}}',
        selectionGeneric: 'Selección',
    },

    share: {
        text: 'Colgué los botines 🎙️\n\nMi carrera como {{nombre}} ({{posicion}}):\n⚽ {{goles}} goles · 🅰️ {{asistencias}} asistencias en {{partidos}} partidos\n{{palmares}}\n📈 Mejor media {{rating}}\n\n¡Jugá tu carrera en www.footy-games.com.ar!',
        league_one: 'liga',
        league_other: 'ligas',
        statsTitle: 'Estadísticas',
        statPartidos: 'PARTIDOS',
        statGoles: 'GOLES',
        statAsistencias: 'ASISTENCIAS',
        statTitulos: 'TÍTULOS',
        bestRatingLabel: 'MEJOR MEDIA',
        trophiesTitle: 'Palmarés',
        nationalTeamTitle: 'Selección Nacional',
        careerTitle: 'Trayectoria',
        footer: 'Jugá tu carrera en www.footy-games.com.ar',
        season_one: 'temporada',
        season_other: 'temporadas',
        year_one: 'año',
        year_other: 'años',
        mundial_one: 'Mundial',
        mundial_other: 'Mundiales',
        bestLine: 'Mejor: Mundial ciclo {{ciclo}} (edad {{edad}})',
        header: '⚽  FOOTY · CARRERA DE ÉLITE',
        shareTitle: 'Mi carrera en Footy',
        selChipGoals: 'Goles',
        selChipAssists: 'Asist.',
        selChipMatches: 'PJ',
        mundialRow: 'Mundial #{{ciclo}} · edad {{edad}}',
        clubStatsRow: '{{pj}} PJ · {{g}} G · {{a}} A',
        selStatsRow: '{{pj}} PJ · {{g}}G',
    },

    tactica: {
        axis: { formacion: 'Formación', actitud: 'Actitud', presion: 'Presión', estilo: 'Estilo de ataque', marca: 'Marca' },
        values: {
            defensiva: 'Defensiva', equilibrada: 'Equilibrada', ofensiva: 'Ofensiva', todo_o_nada: 'A todo o nada',
            repliegue: 'Repliegue', media: 'Media', alta: 'Presión alta',
            posesion: 'Posesión', directo: 'Juego directo', bandas: 'Por las bandas', contra: 'Contraataque',
            zona: 'En zona', hombre: 'Al hombre',
        },
    },

    attributes: {
        velocidad: 'Velocidad', tiro: 'Tiro', fisico: 'Físico', pase: 'Pase',
        defensa: 'Capacidad Defensiva', fiesta: 'Fiesta y Alcohol',
    },

    positions: {
        'Defensor Lateral': 'Defensor Lateral',
        'Defensor Central': 'Defensor Central',
        'Mediocampista Defensivo': 'Mediocampista Defensivo',
        'Mediocampista Ofensivo': 'Mediocampista Ofensivo',
        'Delantero Extremo': 'Delantero Extremo',
        'Delantero Centro': 'Delantero Centro',
    },

    mundialResult: { campeon: '🏆 Campeón', final: '🥈 Final', semis: 'Semifinal', cuartos: 'Cuartos', octavos: 'Octavos', '16avos': '16avos', grupos: 'Fase de grupos', no_clasif: 'No clasificó' },

    scouting: {
        defensiva: '🕵️ Se van a meter atrás.',
        equilibrada: '🕵️ Van a jugar parejo, sin arriesgar.',
        ofensiva: '🕵️ Te van a salir a buscar.',
        todo_o_nada: '🕵️ Van a ir con todo al ataque.',
        repliegue: '🕵️ Te esperan replegados.',
        media: '🕵️ Presionan en su mitad.',
        alta: '🕵️ Vienen a presionarte arriba.',
        posesion: '🕵️ Les gusta tener la pelota.',
        directo: '🕵️ Juegan directo y al vacío.',
        bandas: '🕵️ Atacan mucho por las bandas.',
        contra: '🕵️ Esperan para salir de contra.',
    },

    tacticaFeedback: {
        messyWin: '🤔 Esquema algo descosido, pero lo sacaste adelante.',
        messyLose: '🤯 Tu planteo fue contradictorio y se notó en la cancha.',
        sharpWin: '🧠 Leíste perfecto al rival: tu planteo los rompió.',
        sharpLose: '🧠 Planteo acertado, te faltó eficacia arriba.',
        outreadWin: '😮‍💨 El rival te ganó la pizarra, pero zafaste.',
        outreadLose: '❌ Te leyeron el planteo y te pasaron por encima.',
        neatWin: '✅ Planteo prolijo y a ganar.',
        neatDraw: '➖ Planteo parejo, repartieron puntos.',
        neatLose: '🔻 Planteo correcto, no se te dio.',
    },

    achievements: {
        facil_5_ligas: { title: 'Pentacampeón local', desc: 'Ganar 5 ligas locales en una misma carrera.' },
        facil_champions: { title: 'Rey de Europa', desc: 'Ganar una Champions League.' },
        facil_europa: { title: 'Conquista continental', desc: 'Ganar una Europa League.' },
        facil_sudamericana: { title: 'Gloria sudamericana', desc: 'Ganar una Copa Sudamericana.' },
        facil_libertadores: { title: 'La Gloria Eterna', desc: 'Ganar una Copa Libertadores.' },
        facil_5_grandes: { title: 'Trotamundos de élite', desc: 'Jugar en las 5 grandes ligas (España, Francia, Inglaterra, Italia, Alemania) de primera división en una misma carrera.' },
        facil_media_85: { title: 'Figura', desc: 'Llegar a 85 de media en una temporada.' },
        sel_facil_convocado: { title: 'Convocado', desc: 'Ser convocado a tu selección al menos una vez.' },
        sel_facil_5_goles: { title: 'Goleador nacional', desc: 'Hacer 25 goles con tu selección en una misma carrera.' },
        sel_facil_clasificar: { title: 'Al Mundial', desc: 'Clasificar a un Mundial con tu selección.' },
        medio_5_ligas_5_equipos: { title: 'Campeón nómade', desc: 'Ganar 5 ligas locales con 5 equipos diferentes en una misma carrera.' },
        medio_3_intl_3_equipos: { title: 'Trotamundos campeón', desc: 'Ganar 3 trofeos internacionales con 3 equipos diferentes en una misma carrera.' },
        medio_5_ligas_mismo: { title: 'Ídolo eterno', desc: 'Ganar 5 ligas locales con el mismo equipo.' },
        medio_remontada_0_3: { title: 'Remontada épica', desc: 'Dar vuelta un partido empezándolo perdiendo 3-0.' },
        medio_3_clubs_5est: { title: 'Solo para cracks', desc: 'Jugar en 3 equipos de 5 estrellas de valoración en una misma carrera.' },
        medio_45_atrib: { title: 'Físico de élite', desc: 'Aplicar 45 puntos de atributos en una misma carrera.' },
        medio_750_goles: { title: 'Máquina de goles', desc: 'Hacer más de 750 goles en una misma carrera.' },
        medio_media_90: { title: 'Crack', desc: 'Llegar a 90 de media en una temporada.' },
        medio_liber_liga: { title: 'Doblete sudamericano', desc: 'Ganar Libertadores y Liga local en una misma temporada.' },
        medio_champ_liga: { title: 'Doblete europeo', desc: 'Ganar Champions y Liga local en una misma temporada.' },
        sel_medio_semifinal: { title: 'Entre los 4 mejores', desc: 'Llegar a la semifinal del Mundial con tu selección.' },
        sel_medio_gol_ko: { title: 'Gol en el mata-mata', desc: 'Hacer un gol en un Mundial en un partido de eliminación directa (16avos en adelante).' },
        sel_medio_clasif_15est: { title: 'Cenicienta mundialista', desc: 'Clasificar a un Mundial con una selección de 1.5 estrellas o menos.' },
        sel_medio_final_35est: { title: 'Sorpresa mundial', desc: 'Llegar a la final del Mundial con una selección de 3.5 estrellas o menos.' },
        sel_medio_25_goles: { title: 'Artillero de selección', desc: 'Hacer más de 50 goles con tu selección en una misma carrera.' },
        dificil_900_goles: { title: 'Leyenda goleadora', desc: 'Hacer más de 900 goles en una misma carrera.' },
        dificil_750_asist: { title: 'Generador de juego', desc: 'Hacer más de 750 asistencias en una misma carrera.' },
        imposible_900_asist: { title: 'Mago de las asistencias', desc: 'Hacer más de 900 asistencias en una misma carrera.' },
        dificil_sudam_2est: { title: 'Cenicienta sudamericana', desc: 'Ganar una Sudamericana con un club de 2 estrellas o menos.' },
        dificil_europa_25est: { title: 'Sorpresa europea', desc: 'Ganar una Europa League con un club de 2 estrellas y media o menos.' },
        dificil_intl_invicto: { title: 'Camino perfecto', desc: 'Ganar un torneo internacional invicto.' },
        dificil_liber_cada_pais: { title: 'Dueño de la Libertadores', desc: 'Ganar una Libertadores con cada país de Sudamérica (no necesariamente en una misma carrera).' },
        dificil_sudam_cada_pais: { title: 'Dueño de la Sudamericana', desc: 'Ganar una Sudamericana con cada país de Sudamérica (no necesariamente en una misma carrera).' },
        dificil_champ_cada_pais: { title: 'Dueño de la Champions', desc: 'Ganar una Champions con cada país de Europa (no necesariamente en una misma carrera).' },
        dificil_europa_cada_pais: { title: 'Dueño de la Europa League', desc: 'Ganar una Europa League con cada país de Europa (no necesariamente en una misma carrera).' },
        dificil_media_95: { title: 'Súper crack', desc: 'Llegar a 95 de media en una temporada.' },
        dificil_50_atrib: { title: 'Máximo potencial', desc: 'Aplicar 50 puntos de atributos en una misma carrera.' },
        dificil_un_club: { title: 'Eterno e inquebrantable', desc: 'Jugar toda la carrera en el mismo club y retirarte por edad (no vale el retiro voluntario).' },
        sel_dificil_campeon: { title: 'Campeón del Mundo', desc: 'Salir campeón del Mundial con tu selección.' },
        sel_dificil_gol_final: { title: 'Gol en la final', desc: 'Hacer un gol en la final del Mundial con tu selección.' },
        sel_dificil_5_mundiales: { title: 'Cinco Mundiales', desc: 'Jugar 5 Mundiales distintos.' },
        sel_dificil_8_goles_mun: { title: 'Botín de Oro', desc: 'Hacer más de 8 goles en un mismo Mundial.' },
        sel_dificil_50_goles: { title: 'Leyenda de selección', desc: 'Hacer más de 75 goles con tu selección en una misma carrera.' },
        imposible_un_club_3est: { title: 'Leyenda de un solo club', desc: 'Jugar toda la carrera en el mismo club de mínimo 3 estrellas de valoración y retirarte por edad (no vale el retiro voluntario).' },
        imposible_libertadores_2est: { title: 'Milagro libertador', desc: 'Ganar una Libertadores con un club de 2 estrellas o menos.' },
        imposible_champions_25est: { title: 'Gesta inmortal', desc: 'Ganar una Champions con un club de 2 estrellas y media o menos.' },
        imposible_liga_invicto_18: { title: 'Los Invencibles', desc: 'Ganar una liga local de 18 o más equipos invicto (primera división).' },
        imposible_media_99: { title: 'El mejor de la historia', desc: 'Llegar a 99 de media en una temporada.' },
        sel_imp_campeon_2est: { title: 'Hazaña mundial', desc: 'Ganar el Mundial con una selección de 2 estrellas o menos.' },
        sel_imp_12_goles_mun: { title: 'Just \'Like\' Fontaine', desc: 'Hacer mínimo 13 goles en un mismo Mundial.' },
        sel_imp_3_mundiales_gan: { title: 'O\'Rei Pelé', desc: 'Ganar 3 Mundiales en una misma carrera.' },
        sel_imp_75_goles: { title: 'Goleador histórico', desc: 'Hacer más de 100 goles con tu selección en una misma carrera.' },
    },
    eventos: {
            "fiesta_previa": {
                texto: "Te invitan a una fiesta la noche antes de un partido importante.",
                opt0: { label: "🍻 Voy y le doy con todo", out0: "La rompiste y al otro día fresquísimo. (+moral)", out1: "Llegaste hecho percha, el DT te re-puteó. (−moral)" },
                opt1: { label: "🍷 Voy un rato y me piro temprano", out0: "Saludaste a todos y descansaste. Equilibrio. (+moral)", out1: "Te fuiste justo cuando se ponía buena. Bah." },
                opt2: { label: "🛌 Me quedo a descansar", out0: "Profesional total. (+moral)", out1: "No dormiste igual pensando en lo que te perdías. (−moral)" },
            },
            "entreno_extra": {
                texto: "El preparador te ofrece quedarte a hacer trabajo extra.",
                opt0: { label: "💪 Me mato entrenando", out0: "El laburo dio frutos: +1 punto de atributo.", out1: "Te exigiste de más y quedaste con una molestia. (−moral)" },
                opt1: { label: "🏃 Hago un poco nomás", out0: "Sumaste sin arriesgar. (+moral)", out1: "Trote suave y a casa. Normal." },
                opt2: { label: "🚗 Me voy a casa", out0: "Descansaste. Nada nuevo.", out1: "El profe lo tomó como falta de compromiso. (−moral)" },
            },
            "sponsor": {
                texto: "Una marca te ofrece ser la cara de su campaña.",
                opt0: { label: "✍️ Firmo el contratazo", out0: "Tu cara en todos lados, te subió el ánimo. (+moral)", out1: "La campaña fue un papelón y te cargaron. (−moral)" },
                opt1: { label: "🤝 Negocio mejores condiciones", out0: "Sacaste más guita con paciencia. (+moral)", out1: "Te pasaste de pedidos y se cayó todo. (−moral)" },
                opt2: { label: "🙅 Paso", out0: "Perfil bajo, foco en el fútbol. (+moral)", out1: "Tus compañeros te dijeron tonto por la guita. (−moral)" },
            },
            "prensa": {
                texto: "Un periodista te bardea diciendo que estás sobrevalorado.",
                opt0: { label: "🔥 Le contesto fuerte", out0: "Lo cruzaste con clase, la hinchada te bancó. (+moral)", out1: "Te calentaste de más y quedaste mal. (−moral)" },
                opt1: { label: "😏 Le tiro una chicana fina", out0: "Lo dejaste sin respuesta. Genio. (+moral)", out1: "Nadie entendió tu ironía. Pasó." },
                opt2: { label: "😶 Lo ignoro", out0: "Hablás con los pies. (+moral)", out1: "Tu silencio se leyó como que tenía razón. (−moral)" },
            },
            "vestuario": {
                texto: "Hay tensión en el vestuario entre dos referentes.",
                opt0: { label: "🕊️ Medio y calmo las aguas", out0: "Pusiste paños fríos, te valoran como líder. (+moral)", out1: "Te metiste donde no debías. (−moral)" },
                opt1: { label: "🤐 Me mantengo neutral", out0: "No tomaste partido. Sano.", out1: "Pasó de largo sin tu intervención." },
                opt2: { label: "🍿 Tiro nafta al fuego", out0: "El quilombo escaló y se notó en la cancha. (−moral)", out1: "Te divertiste con el cabaret. (+moral leve)" },
            },
            "molestia": {
                texto: "Arrastrás una molestia y el cuerpo médico te deja elegir.",
                opt0: { label: "🏃 Fuerzo y juego", out0: "Aguantaste y rendiste. Invencible. (+moral)", out1: "Te resentiste feo. (−moral)" },
                opt1: { label: "💊 Me infiltro y veo", out0: "Aguantó el partido justo. (+moral leve)", out1: "La infiltración te dejó peor. (−moral)" },
                opt2: { label: "🧊 Descanso y me cuido", out0: "Volvés entero. (+moral)", out1: "Era una pavada, te perdiste el partido al pedo. (−moral)" },
            },
            "hincha": {
                texto: "Un nene te espera 3 horas en la puerta del club para conocerte.",
                opt0: { label: "🤗 Le firmo y me saco fotos", out0: "El video se hizo viral, sos lo más querido. (+moral)", out1: "Le alegraste el día. Hermoso. (+moral)" },
                opt1: { label: "✋ Lo saludo al pasar", out0: "Gesto cortito pero amable. (+moral leve)", out1: "Apenas lo viste. Pasó." },
                opt2: { label: "🏃 Estoy apurado, otro día", out0: "Lo dejaste plantado y salió en las redes. (−moral)", out1: "Tenías médico, lo entendieron." },
            },
            "casino": {
                texto: "Unos compañeros te invitan al casino después del partido.",
                opt0: { label: "🎲 Apuesto fuerte", out0: "Te llenaste de fichas. (+moral)", out1: "Perdiste guita y horas de sueño. (−moral)" },
                opt1: { label: "🍹 Voy a acompañar nomás", out0: "Te despejaste sin gastar. (+moral leve)", out1: "Una gaseosa y a casa. Tranqui." },
                opt2: { label: "🏠 Me vuelvo a casa", out0: "Cabeza fría. (+moral leve)", out1: "Te perdiste una noche épica. (−moral)" },
            },
            "asado": {
                texto: "Asado de plantel y te toca a vos el fuego.",
                opt0: { label: "🔥 Me hago cargo de la parrilla", out0: "Asado nivel Dios, te ganaste al vestuario. (+moral)", out1: "Quemaste la carne y te cargaron. (−moral)" },
                opt1: { label: "🥗 Me encargo de las ensaladas", out0: "Cumpliste sin riesgo. (+moral leve)", out1: "Nadie comió ensalada. Bah." },
                opt2: { label: "🥤 Llevo la bebida nomás", out0: "Misión simple cumplida.", out1: "Trajiste gaseosa caliente. Papelón. (−moral)" },
            },
            "tatuaje": {
                texto: "Querés hacerte un tatuaje para la previa del torneo.",
                opt0: { label: "🖊️ El escudo gigante en el brazo", out0: "La hinchada flasheó ídolo. (+moral)", out1: "Quedó horrible y te lo querés borrar. (−moral)" },
                opt1: { label: "🤏 Algo chiquito y discreto", out0: "Sutil y canchero. (+moral leve)", out1: "Nadie lo notó." },
                opt2: { label: "🚫 Mejor no me hago nada", out0: "Cero arrepentimientos.", out1: "Te quedaste con las ganas. (−moral leve)" },
            },
            "representante": {
                texto: "Tu representante te dice que te puede conseguir un pase a un club más grande \"ya mismo\".",
                opt0: { label: "🌍 Confío de una", out0: "Te ilusionó con un equipazo. (+moral)", out1: "Era todo humo. (−moral)" },
                opt1: { label: "📑 Le pido que me muestre todo por escrito", out0: "Profesional, te cubriste. (+moral)", out1: "No tenía nada concreto. Pasó." },
                opt2: { label: "🧐 Le digo que se calme", out0: "Pies sobre la tierra. (+moral leve)", out1: "Justo era oferta real y la perdiste. (−moral)" },
            },
            "mediatico": {
                texto: "Empezás a salir con una figura mediática y la tele explota.",
                opt0: { label: "📺 Disfruto la fama", out0: "La llevás bien y te divierte. (+moral)", out1: "El circo te desconcentró mal. (−moral)" },
                opt1: { label: "🤫 Lo mantengo en privado", out0: "Perfil bajo, cabeza en el fútbol. (+moral)", out1: "Lo filtraron igual y quedaste de mentiroso. (−moral)" },
                opt2: { label: "🚪 Lo corto, me distrae", out0: "Foco total. (+moral leve)", out1: "Te quedaste pensando en lo que dejaste. (−moral)" },
            },
            "var": {
                texto: "El finde el VAR te anuló un golazo y las redes todavía explotan a tu favor.",
                opt0: { label: "😡 Salgo a putear al VAR", out0: "La hinchada te bancó a muerte. (+moral)", out1: "Te comiste una fecha de suspensión. (−moral)" },
                opt1: { label: "🤷 Tiro un comentario irónico", out0: "Quedó canchero y gracioso. (+moral)", out1: "Nadie le dio bola." },
                opt2: { label: "🙏 Lo dejo pasar", out0: "Tranquilo, ya llega el desquite. (+moral)", out1: "Por adentro quedaste caliente toda la semana. (−moral)" },
            },
            "auto": {
                texto: "Con el primer sueldo grande te querés comprar un auto carísimo.",
                opt0: { label: "🤑 Me compro el más caro", out0: "Pose total. (+moral)", out1: "Lo chocaste a la semana. Papelón. (−moral)" },
                opt1: { label: "🚙 Algo lindo pero sensato", out0: "Buen gusto y prudencia. (+moral leve)", out1: "Auto normalito. Cumple." },
                opt2: { label: "🏦 Mejor ahorro", out0: "Tu vieja orgullosa. (+moral)", out1: "Te quedaste con las ganas. Bah." },
            },
            "tarde": {
                texto: "Te quedaste dormido y llegás tarde al entrenamiento.",
                opt0: { label: "🏃 Invento una excusa", out0: "Zafaste con un \"se me pinchó la goma\".", out1: "El DT no te creyó y te multó. (−moral)" },
                opt1: { label: "🤐 Entro callado y disimulo", out0: "Nadie te vio entrar. Suerte.", out1: "Te pescaron igual. (−moral)" },
                opt2: { label: "📞 Aviso y banco la multa", out0: "Sinceridad valorada. (+moral)", out1: "Igual quedaste de impuntual. (−moral)" },
            },
            "foto_filtrada": {
                texto: "Se filtró una foto tuya de joda a las 4 AM en un boliche.",
                opt0: { label: "😎 La banco, \"estaba de franco\"", out0: "Te reíste de vos mismo, quedó en chiste. (+moral)", out1: "La dirigencia te llamó la atención feo. (−moral)" },
                opt1: { label: "🙈 Pido disculpas públicas", out0: "Apagaste el incendio. Lección aprendida. (+moral)", out1: "Al final la foto era IA, ni eras vos. Te quemaste solo. (−moral)", out2: "Nadie le dio bola a tus disculpas." },
                opt2: { label: "🤐 No digo nada", out0: "Se olvidaron en dos días.", out1: "El silencio se interpretó como culpa. (−moral)" },
            },
            "tv_baile": {
                texto: "Te invitan a un programa de baile en plena temporada.",
                opt0: { label: "🕺 Acepto, soy figura", out0: "La rompiste bailando, ganaste fans. (+moral)", out1: "Papelón y encima llegaste cansado a entrenar. (−moral)" },
                opt1: { label: "📅 Acepto pero solo en el parate", out0: "Lo manejaste sin descuidar el fútbol. (+moral)", out1: "Quedó para más adelante. Bah." },
                opt2: { label: "🙅 No, estoy enfocado", out0: "Primero el laburo. (+moral)", out1: "El que fue se hizo famoso. (−moral)" },
            },
            "comedor": {
                texto: "Un comedor del barrio te pide una mano para los chicos.",
                opt0: { label: "🤝 Dono y voy a saludar", out0: "Les alegraste la vida, no se paga con nada. (+moral)", out1: "Lindo gesto, aunque te agarró la lluvia. (+moral)" },
                opt1: { label: "💸 Mando plata pero no voy", out0: "Ayudaste igual. (+moral)", out1: "Dijeron que sos frío por no aparecer. (−moral)" },
                opt2: { label: "🤷 Lo dejo para después", out0: "Quedó pendiente. Pasó.", out1: "Se hizo público que ni contestaste. (−moral)" },
            },
            "provocacion": {
                texto: "En el último partido un rival te provocó todo el tiempo. Te lo cruzás en un evento.",
                opt0: { label: "👊 Lo encaro", out0: "Aclararon de hombre a hombre. (+moral)", out1: "Casi se van a las manos y salió en todos lados. (−moral)" },
                opt1: { label: "🤝 Le ofrezco la mano", out0: "Gesto deportivo, quedaste bien. (+moral)", out1: "Te dejó la mano colgada. Igual quedaste bien vos." },
                opt2: { label: "🧊 Lo ignoro", out0: "El que se calienta pierde. (+moral)", out1: "Te quedó la bronca adentro. (−moral)" },
            },
            "cumple": {
                texto: "Cumple de un compañero y hay previa fuerte el jueves.",
                opt0: { label: "🍾 Voy y le doy", out0: "Festejaste sano, reforzaste el grupo. (+moral)", out1: "Te excediste y el finde jugaste como un tronco. (−moral)" },
                opt1: { label: "🥂 Saludo y me voy temprano", out0: "Equilibrio perfecto. (+moral)", out1: "Te perdiste lo mejor. Bah." },
                opt2: { label: "🎁 Le mando un regalo y no voy", out0: "Detallista. Cumpliste.", out1: "Se ofendió porque no apareciste. (−moral)" },
            },
            "mate_dt": {
                texto: "El técnico te invita a unos mates para charlar tu rol.",
                opt0: { label: "🧉 Me siento y lo escucho", out0: "Te dio confianza y te bancó. (+moral)", out1: "Te dijo que estás en duda. Bajón. (−moral)" },
                opt1: { label: "🗣️ Le planteo lo que pienso", out0: "Te respetó la sinceridad. (+moral)", out1: "No le gustó nada lo que dijiste. (−moral)" },
                opt2: { label: "🙄 Voy de compromiso", out0: "Te notó tibio. (−moral)", out1: "Charlaron de cualquier cosa." },
            },
            "apuesta": {
                texto: "Un \"amigo\" te ofrece plata para \"aflojar\" en un partido.",
                opt0: { label: "🚪 Lo rajo al toque", out0: "Integridad total. (+moral)", out1: "Hiciste bien, aunque te quedó mal cuerpo. (+moral)" },
                opt1: { label: "🤫 Le digo que lo voy a pensar", out0: "Quedaste expuesto a un quilombo. (−moral)", out1: "Lo cortaste antes de que pase a mayores." },
                opt2: { label: "🚨 Lo denuncio al club", out0: "Jugaste limpio y te blindaste. (+moral)", out1: "El tipo te empezó a amenazar. (−moral)" },
            },
            "cabala": {
                texto: "Venís invicto y la cábala es no lavar las medias de la suerte.",
                opt0: { label: "🤢 Las sigo usando", out0: "Sigue la racha. (+moral)", out1: "Se cortó igual y olés horrible. (−moral)" },
                opt1: { label: "🌬️ Las aireo pero no las lavo", out0: "Compromiso cabalero. (+moral leve)", out1: "Ni fu ni fa." },
                opt2: { label: "🧼 Las lavo, soy grande", out0: "Higiene ante todo. (+moral leve)", out1: "Justo perdiste y todos te culparon. (−moral)" },
            },
            "utilero": {
                texto: "El utilero del club está pasando un mal momento personal.",
                opt0: { label: "🤗 Le doy una mano grande", out0: "La gente del club te quiere cada día más. (+moral)", out1: "Gesto noble, aunque medio incómodo. (+moral)" },
                opt1: { label: "👂 Lo escucho un rato", out0: "Le hizo bien desahogarse. (+moral)", out1: "Charlaron y siguió cada uno." },
                opt2: { label: "😶 No es mi tema", out0: "Frialdad, en el club lo notaron. (−moral)", out1: "Otro se hizo cargo." },
            },
            "influencer": {
                texto: "Un influencer te ofrece seguidores por un challenge ridículo.",
                opt0: { label: "📲 Lo hago, qué me importa", out0: "Se hizo viral, le pusiste onda. (+moral)", out1: "Quedó cringe y te cargaron. (−moral)" },
                opt1: { label: "🎬 Lo hago pero a mi manera", out0: "Le diste tu impronta y gustó. (+moral)", out1: "Pasó sin pena ni gloria." },
                opt2: { label: "🙅 Ni en pedo", out0: "Dignidad intacta. (+moral leve)", out1: "El que lo hizo ganó un millón de seguidores. (−moral)" },
            },
            "pelota_hattrick": {
                texto: "En el último partido metiste un hat-trick y te quedaste con la pelota.",
                opt0: { label: "🖊️ La firmo y la cuelgo en casa", out0: "Recuerdo eterno. (+moral)", out1: "Junta polvo en un estante." },
                opt1: { label: "🎁 La subasto para una causa", out0: "Recaudaste un montón para los pibes. (+moral)", out1: "Nadie ofertó mucho, medio papelón. (−moral)" },
                opt2: { label: "⚽ La uso para entrenar", out0: "Pelota con historia, le metés horas. (+moral leve)", out1: "Se pinchó a la semana. Bah." },
            },
            "capitan_fecha": {
                texto: "El DT te ofrece la cinta de capitán por una fecha.",
                opt0: { label: "💪 La agarro y meto huevo", out0: "Liderazgo total, te respetan. (+moral)", out1: "Quisiste arengar y nadie te dio bola. (−moral)" },
                opt1: { label: "🤝 La acepto pero sin sobreactuar", out0: "Lideraste con el ejemplo. (+moral)", out1: "Fecha tranquila, cumpliste." },
                opt2: { label: "😰 No me la banco, paso", out0: "Mostraste inseguridad. (−moral)", out1: "El DT entendió que no era tu momento." },
            },
            "barra": {
                texto: "La barra te invita a \"una reunión\" en la sede.",
                opt0: { label: "🤝 Voy y me hago amigo", out0: "Mala junta, quedaste pegado a un quilombo. (−moral)", out1: "Te diste cuenta a tiempo y te abriste. (−moral)" },
                opt1: { label: "📵 No contesto", out0: "Mejor lejos de eso.", out1: "Se ofendieron y te tienen de punto. (−moral)" },
                opt2: { label: "🛡️ Aviso al club", out0: "Jugaste limpio, la dirigencia te bancó. (+moral)", out1: "La barra se enteró y te marcó. (−moral)" },
            },
            "documental": {
                texto: "Una productora te quiere hacer un documental de tu vida.",
                opt0: { label: "🎥 Acepto y muestro TODO", out0: "Quedó épico y humano. (+moral)", out1: "Mostraste de más y quedaste expuesto. (−moral)" },
                opt1: { label: "🎯 Solo lo futbolístico", out0: "Prolijo y profesional. (+moral)", out1: "Salió aburrido y nadie lo vio. (−moral)" },
                opt2: { label: "⏳ Lo dejo para cuando me retire", out0: "Decisión madura.", out1: "La productora se fue con otro." },
            },
            "penales_quiero": {
                texto: "El DT está definiendo quién será el pateador de penales del equipo.",
                opt0: { label: "🙋 Me ofrezco yo", out0: "Te ganaste el puesto y la confianza. (+moral)", out1: "En la práctica erraste 3 al hilo y te descartaron. (−moral)" },
                opt1: { label: "🎯 Le digo que practico y veo", out0: "Te mostraste comprometido. (+moral)", out1: "Quedaste segundo en la lista. Normal." },
                opt2: { label: "🤐 Que patee otro", out0: "No te sumaste la presión.", out1: "El elegido los viene errando, pensás \"yo los metía\". (−moral)" },
            },
            "pibe_inferiores": {
                texto: "Un pibe de inferiores te pide consejos para debutar.",
                opt0: { label: "🧠 Me siento a charlar largo", out0: "Te convertiste en su referente. (+moral)", out1: "Le diste una mano, aunque no entendió nada. (+moral)" },
                opt1: { label: "💬 Le tiro un par de tips", out0: "Consejo corto pero útil. (+moral)", out1: "Apenas lo escuchó. Pasó." },
                opt2: { label: "😒 \"No tengo tiempo, pibe\"", out0: "Lo trataste mal, feo karma. (−moral)", out1: "Estabas a las apuradas, lo entendió." },
            },
            "seleccion_amistoso": {
                texto: "Te convocan a la Selección de {pais} para un amistoso en mitad de temporada.",
                opt0: { label: "🙌 Voy con todo, es un orgullo", out0: "Vestir la camiseta de {pais} te llenó de energía. (+moral)", out1: "Volviste molido del viaje y rendiste mal. (−moral)" },
                opt1: { label: "🤝 Voy pero pido cuidarme", out0: "Sumaste minutos sin fundirte. (+moral)", out1: "Jugaste poquito. Trámite." },
                opt2: { label: "🚫 Me bajo, prefiero descansar", out0: "La prensa de {pais} te crucificó. (−moral)", out1: "Descansaste y volviste como nuevo. (+moral)" },
            },
            "resaca": {
                texto: "Te despertás con resaca y hay doble turno de entrenamiento.",
                opt0: { label: "🤮 Voy como puedo", out0: "Vomitaste en el predio. Vergüenza histórica. (−moral)", out1: "La remaste a duras penas. (−moral)" },
                opt1: { label: "☕ Litros de café y a aguantar", out0: "Zafaste raspando. Nadie notó.", out1: "Igual rendiste pésimo. (−moral)" },
                opt2: { label: "🤧 Aviso que estoy \"engripado\"", out0: "Zafaste, pero te quedó la culpa.", out1: "El médico te revisó y descubrió todo. (−moral)" },
            },
            "mansion": {
                texto: "Te comprás una mansión y querés fiesta de inauguración.",
                opt0: { label: "🎊 Fiestón con 200 invitados", out0: "Legendaria y sin secuelas. (+moral)", out1: "Se descontroló y salió en los diarios. (−moral)" },
                opt1: { label: "🤝 Asado con compañeros", out0: "Uniste al grupo en tu casa nueva. (+moral)", out1: "Se quemó el asado en casa nueva. Mufa." },
                opt2: { label: "🍽️ Cena chica con la familia", out0: "Tranqui y cálido. (+moral leve)", out1: "Inauguración sin onda." },
            },
            "insulto_calle": {
                texto: "Un hincha rival te putea en el súper delante de todos.",
                opt0: { label: "🤬 Le contesto a los gritos", out0: "Casi se van a las manos, te filmaron. (−moral)", out1: "Lo pusiste en su lugar y aplaudieron. (+moral)" },
                opt1: { label: "😏 Le firmo un autógrafo", out0: "Lo desarmaste con clase. (+moral)", out1: "Te lo tiró por la cabeza. (−moral)" },
                opt2: { label: "🛒 Sigo comprando", out0: "Ni lo miraste. Frialdad. (+moral leve)", out1: "Te siguió hasta la caja. Incómodo." },
            },
            "renovacion_charla": {
                texto: "El club te ofrece renovar por menos plata de la esperada.",
                opt0: { label: "😤 Pido el doble o me voy", out0: "Se pudrió la relación con la dirigencia. (−moral)", out1: "Te lo dieron. ¡Te saliste con la tuya! (+moral)" },
                opt1: { label: "🤝 Negocio un punto medio", out0: "Acuerdo justo para los dos. (+moral)", out1: "Quedó la charla abierta. Pasó." },
                opt2: { label: "❤️ Firmo, amo esta camiseta", out0: "La hinchada te idolatra. (+moral)", out1: "Después supiste que a uno peor le pagaban más. (−moral)" },
            },
            "festejo_lesion": {
                texto: "Estás ensayando un festejo acrobático para tu próximo gol.",
                opt0: { label: "🤾 El mortero triple a full", out0: "Te quedó bárbaro, lo vas a romper. (+moral)", out1: "Te lesionaste ENSAYANDO. Insólito. (−moral)" },
                opt1: { label: "🕺 Un bailecito simple", out0: "Pegadizo y sin riesgo. (+moral)", out1: "Medio careta, pero zafa." },
                opt2: { label: "🤫 Lo dedico a mi familia", out0: "Gesto emotivo preparado con amor. (+moral)", out1: "Decidiste improvisar el día del gol." },
            },
            "sesion_fotos": {
                texto: "Sesión de fotos para la nueva camiseta del club.",
                opt0: { label: "😎 Poses ridículas a propósito", out0: "El club no se rió. (−moral)", out1: "Se hicieron meme y la gente te amó. (+moral)" },
                opt1: { label: "🤩 Le pongo onda y carisma", out0: "Las fotos volaron en las redes. (+moral)", out1: "Saliste con los ojos cerrados en todas. (−moral)" },
                opt2: { label: "📸 Cara de jugador serio", out0: "Correcto y profesional.", out1: "Fotos del montón." },
            },
            "jingle": {
                texto: "Te piden grabar un jingle para la publicidad del club.",
                opt0: { label: "🎶 Canto aunque desafino", out0: "Sonó espantoso y te cargaron. (−moral)", out1: "Tan malo que se volvió hit irónico. (+moral)" },
                opt1: { label: "🎸 Le meto flow", out0: "Se volvió hit del club. (+moral)", out1: "Nadie lo recuerda. (−moral leve)" },
                opt2: { label: "🗣️ Hablo, no canto", out0: "Saliste del paso decente.", out1: "Quedó plano. Pasó." },
            },
            "bandera": {
                texto: "La hinchada prepara una bandera gigante con tu cara.",
                opt0: { label: "😭 Me emociono y la abrazo", out0: "Imagen para la historia del club. (+moral)", out1: "Te tropezaste y casi la rompés. Susto." },
                opt1: { label: "🙌 La saludo desde lejos", out0: "Gesto cálido y simple. (+moral)", out1: "No te vieron bien. Bah." },
                opt2: { label: "😬 Digo que me incomoda", out0: "La hinchada se ofendió. (−moral)", out1: "Lo entendieron, sos tímido." },
            },
            "esquema_dt": {
                texto: "No estás de acuerdo con el esquema del técnico.",
                opt0: { label: "🗯️ Lo discuto delante de todos", out0: "Lo dejaste mal, fuiste al banco. (−moral)", out1: "Tenías razón y el equipo mejoró. (+moral)" },
                opt1: { label: "🚪 Hablo con él en privado", out0: "Charla madura, te tuvo más en cuenta. (+moral)", out1: "Te mandó a callar. (−moral)" },
                opt2: { label: "🤐 Me lo guardo", out0: "Te mordiste la lengua. Sigue igual.", out1: "La bronca te jugó en contra. (−moral)" },
            },
            "mascota": {
                texto: "Un perro callejero se queda con el plantel en el predio.",
                opt0: { label: "🦴 Lo adopto de mascota del equipo", out0: "Es la nueva cábala, todos felices. (+moral)", out1: "Te mordió justo a vos. (−moral)" },
                opt1: { label: "🍖 Le doy de comer y veo", out0: "Buen gesto, el plantel lo bancó. (+moral)", out1: "Se fue al otro día. Pasó." },
                opt2: { label: "🚷 Que lo saquen", out0: "Quedaste como el malo. (−moral)", out1: "Tenías alergia, lo entendieron." },
            },
            "fifa_noche": {
                texto: "Maratón de FIFA con los compañeros hasta cualquier hora.",
                opt0: { label: "🌙 Hasta las 5 AM sin parar", out0: "Llegaste muerto al entrenamiento. (−moral)", out1: "Ganaste el torneo y la gloria del vestuario. (+moral)" },
                opt1: { label: "🎮 Un par de partidas y a dormir", out0: "Te divertiste sin pasarte. (+moral)", out1: "Perdiste rápido y te fuiste. Bah." },
                opt2: { label: "😴 Hoy descanso", out0: "Profesional como pocos. (+moral)", out1: "Te perdiste una noche épica." },
            },
            "cerveza_marca": {
                texto: "Una cerveza te ofrece ser su imagen en plena pretemporada.",
                opt0: { label: "🍻 Firmo y voy a los eventos", out0: "La llevaste bien sin descuidar el físico. (+moral)", out1: "Tanto evento te dejó pesado. (−moral)" },
                opt1: { label: "📝 Firmo pero sin eventos", out0: "Buena guita, cero líos. (+moral)", out1: "Solo la publicidad. Normal." },
                opt2: { label: "🚫 No, estoy en pretemporada", out0: "Foco total. (+moral)", out1: "Perdiste un contratazo, tu representante furioso. (−moral)" },
            },
            "camiseta_partido": {
                texto: "Un nene te escribe por las redes pidiéndote una camiseta firmada.",
                opt0: { label: "👕 Se la mando con dedicatoria", out0: "Postal del año, el nene a las lágrimas. (+moral)", out1: "Lindo gesto, aunque el correo la perdió un mes. (+moral)" },
                opt1: { label: "📸 Le mando una foto firmada", out0: "Gesto simple pero lo valoró. (+moral leve)", out1: "Quería la camiseta, quedó medio dolido." },
                opt2: { label: "😶 No tengo tiempo para eso", out0: "El mensaje se viralizó, no quedó lindo. (−moral)", out1: "Andabas a mil, ni lo viste." },
            },
            "avion_demora": {
                texto: "El avión se demora 6 horas y todos están de mal humor.",
                opt0: { label: "🃏 Propongo una partida de cartas", out0: "Uniste al grupo en la espera. (+moral)", out1: "Nadie quiso jugar, quedaste solo. (−moral)" },
                opt1: { label: "🎧 Me pongo los auriculares", out0: "Aguantaste en tu mundo.", out1: "Pasó la espera, ni te enteraste." },
                opt2: { label: "😡 Me quejo a los gritos", out0: "Contagiaste el mal clima. (−moral)", out1: "Tu queja sirvió y nos cambiaron de vuelo. (+moral)" },
            },
            "ingles": {
                texto: "Te ofrecen un curso de inglés pensando en tu proyección internacional.",
                opt0: { label: "🎯 Le meto con todo", out0: "Cabeza puesta en crecer. (+moral)", out1: "No entendiste nada y te frustraste. (−moral)" },
                opt1: { label: "📖 Voy de a ratos", out0: "Algo es algo.", out1: "Avanzás lento pero seguro." },
                opt2: { label: "😴 Qué paja, lo dejo", out0: "Cero ganas de progresar. (−moral)", out1: "Total con señas te entendés. Bah." },
            },
            "penal_superclasico": {
                texto: "Se viene el superclásico. El DT pregunta quién se anima a patear si hay un penal.",
                opt0: { label: "🎯 Me ofrezco yo, me la banco", out0: "El DT te eligió, te sentís imparable. (+moral)", out1: "Te ofreciste pero eligió a otro. Expuesto. (−moral)" },
                opt1: { label: "🤔 Si nadie quiere, lo pateo", out0: "Mostraste personalidad sin presionar. (+moral)", out1: "Se ofreció otro antes. Pasó." },
                opt2: { label: "🙈 Que pateen los de experiencia", out0: "Mostraste que la presión te pesa. (−moral)", out1: "Decisión sensata, el DT lo valoró. (+moral)" },
            },
            "comentarista": {
                texto: "Te invitan a ser comentarista por un día.",
                opt0: { label: "🗣️ Critico a todos", out0: "Te ganaste enemigos en los dos vestuarios. (−moral)", out1: "Filoso y picante, la gente te amó. (+moral)" },
                opt1: { label: "😄 Le pongo humor", out0: "Te pidieron de comentarista fijo. (+moral)", out1: "Te trabaste y quedaste mudo en vivo. (−moral)" },
                opt2: { label: "🎙️ Comento neutral", out0: "Correcto, sin polémica.", out1: "Aburrido pero prolijo." },
            },
            "tatuador_amuleto": {
                texto: "Un brujo te ofrece un amuleto \"para no errar nunca más un gol\".",
                opt0: { label: "💸 Le pago una fortuna", out0: "Era un chanta, te clavó la guita. (−moral)", out1: "Casualidad o no, metiste 3 goles seguidos. (+moral)" },
                opt1: { label: "🪙 Le doy una moneda por las dudas", out0: "Por las dudas, no perdés nada. (+moral leve)", out1: "El amuleto no hizo nada. Obvio." },
                opt2: { label: "😂 Me cago de risa en su cara", out0: "Te divirtió la situación. (+moral)", out1: "Te tiró una \"mufa\" y a la semana la erraste fácil. (−moral)" },
            },
            "balon_oro_gala": {
                texto: "Te invitan a la gala del Balón de Oro, aunque sabés que no ganás este año.",
                opt0: { label: "🎩 Voy con toda la onda", out0: "Disfrutaste la noche entre los mejores del mundo. (+moral)", out1: "Te aburriste esperando 3 horas por nada. (−moral)" },
                opt1: { label: "📱 Voy, saco fotos y me voy temprano", out0: "Cumpliste el compromiso sin desgaste. (+moral)", out1: "Nadie notó que te fuiste antes." },
                opt2: { label: "🙅 Prefiero no ir", out0: "Descansaste tranquilo en casa.", out1: "Tu representante se enojó por el plantón. (−moral)" },
            },
            "polemica_redes": {
                texto: "Publicás una opinión picante sobre el nivel de la liga y se arma quilombo en redes.",
                opt0: { label: "🔥 Sostengo lo que dije", out0: "Te bancaste tu palabra, te respetaron. (+moral)", out1: "Se armó un escándalo mediático enorme. (−moral)" },
                opt1: { label: "😅 Aclaro que era en broma", out0: "Bajaste la tensión con humor. (+moral leve)", out1: "Nadie te creyó. (−moral)" },
                opt2: { label: "🗑️ Borro el posteo", out0: "Se olvidó rápido.", out1: "Ya habían sacado captura. Papelón. (−moral)" },
            },
            "nostalgia_lejos": {
                texto: "Llevás meses lejos de tu país y la nostalgia te está pegando fuerte.",
                opt0: { label: "📞 Videollamada larga con la familia", out0: "Te recargó las pilas del todo. (+moral)", out1: "La conexión se cortaba todo el rato." },
                opt1: { label: "✈️ Me tomo unos días y viajo a verlos", out0: "Volviste renovado y con la cabeza clara. (+moral)", out1: "El viaje relámpago te dejó más cansado. (−moral)" },
                opt2: { label: "💪 Me la aguanto y sigo enfocado", out0: "Profesional hasta el final. (+moral leve)", out1: "La soledad te empezó a pesar de verdad. (−moral)" },
            },
            "nutricionista_estricto": {
                texto: "El nutricionista del club te propone un plan de alimentación muy estricto.",
                opt0: { label: "🥗 Lo sigo al pie de la letra", out0: "Te sentís mucho más liviano en cancha. (+moral)", out1: "Extrañás la comida de siempre. (−moral)" },
                opt1: { label: "🍝 Lo adapto a mi manera", out0: "Encontraste un equilibrio que te funciona. (+moral)", out1: "Ni fu ni fa, seguís igual." },
                opt2: { label: "🍕 Sigo comiendo lo de siempre", out0: "Al menos estás cómodo.", out1: "El cuerpo técnico te llamó la atención. (−moral)" },
            },
            "amistad_rival": {
                texto: "Te hiciste muy amigo de una figura de un equipo rival y la prensa lo critica.",
                opt0: { label: "📸 Lo mostramos igual en redes", out0: "La gente valoró la deportividad. (+moral)", out1: "Una parte de la hinchada te lo reprochó fuerte. (−moral)" },
                opt1: { label: "🤫 Lo mantenemos en privado", out0: "Cuidaste la amistad sin ruido. (+moral)", out1: "Igual se filtró alguna foto." },
                opt2: { label: "🚪 Bajo el perfil con esa amistad", out0: "Menos quilombo mediático.", out1: "Te dolió alejarte de alguien que apreciás. (−moral)" },
            },
            "catastrofe_solidaria": {
                texto: "Un desastre natural golpeó fuerte a una región y el club organiza una ayuda solidaria.",
                opt0: { label: "❤️ Dono una parte grande de mi sueldo", out0: "Tu gesto se hizo viral por las razones correctas. (+moral)", out1: "Ayudaste de verdad, aunque casi nadie se enteró. (+moral)" },
                opt1: { label: "🤝 Participo del partido/evento solidario", out0: "Sumaste presencia y visibilidad a la causa. (+moral)", out1: "Cumpliste con lo básico." },
                opt2: { label: "🤷 Prefiero no involucrarme", out0: "Se notó tu ausencia y quedó mal. (−moral)", out1: "Nadie lo mencionó después." },
            },
        },
};

export default resources;
